export default __webpack_public_path__ + "static/imgR-86e5049752438f60491ed883c0cdec30.png";